export const TOGGLE_QUICK_VIEW_TAB_1 = 'TOGGLE_QUICK_VIEW_TAB_1';
export const TOGGLE_QUICK_VIEW_TAB_2 = 'TOGGLE_QUICK_VIEW_TAB_2';
export const CLOSE_QUICK_VIEW = 'CLOSE_QUICK_VIEW';



// WEBPACK FOOTER //
// ./stores/types/operator/index.js